<script>
  export let name = "";
  export let title = "";
  export let icon;
  export let id = "";
  export let active = false;
  import { createEventDispatcher } from 'svelte';
	const dispatch = createEventDispatcher();

  function handleClick() {
    active = !active
		dispatch('click', {});
  }
</script>

<button id={id} on:click={handleClick} class:active>
  {#if icon}
    <img src={icon} title={title} width="25px" />
  {/if}
  {name}
</button>

<style>
  button {
    font-family: Calibri Light, sans-serif;
    font-weight: bold;
    font-size: 15px;
    border: 1px solid #cccccc;
    border-radius: 4px;
    box-shadow: 1px 1px #dbdbdb;
    height: 40px;
    width: 40px;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-bottom: 5px;
    background-color: #ffffff;
  }

  .active {
    background-color: #e1e1e1;
  }

  img {
    padding: 3px 0;
  }
</style>